/* Celebrity spotted section - behaviour. Owner: sections/kaayu-celeb-spotted.liquid */

function kaayuToggleLike(e, btn) {
  e.stopPropagation();
  btn.classList.toggle('liked');
}

function kaayuCelebAddToCart(e, variantId) {
  e.stopPropagation();
  if (!variantId) return;

  var btn = e.currentTarget;
  var originalText = btn.textContent;
  btn.textContent = 'Adding...';
  btn.disabled = true;

  var cartModal = document.querySelector('cart-modal');

  // Open the drawer immediately, with a loading spinner, instead of waiting on the network first
  if (cartModal && typeof cartModal.show === 'function') {
    cartModal.show();
    if (typeof cartModal.showLoadingOverlay === 'function') {
      cartModal.showLoadingOverlay();
    }
  }

  var sectionsToFetch = ['cart-bubble'];
  if (cartModal && cartModal.sectionId) {
    sectionsToFetch.push(cartModal.sectionId);
  }

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      id: parseInt(variantId),
      quantity: 1,
      sections: sectionsToFetch,
      sections_url: window.location.pathname
    })
  })
    .then(function (res) { return res.json(); })
    .then(function (data) {
      if (data.status) {
        btn.textContent = 'Try Again';
        btn.disabled = false;
        if (cartModal && typeof cartModal.hideLoadingOverlay === 'function') {
          cartModal.hideLoadingOverlay();
        }
        return;
      }

      btn.textContent = 'Added';

      if (data.sections && data.sections['cart-bubble']) {
        var bubble = document.getElementById('CartBubble');
        if (bubble) {
          bubble.classList.remove('hidden');
          bubble.innerHTML = data.sections['cart-bubble'];
        }
      }

      if (cartModal && cartModal.sectionId && data.sections && data.sections[cartModal.sectionId]) {
        cartModal.updateFromSectionHtml(data.sections[cartModal.sectionId]);
      }

      if (cartModal && typeof cartModal.hideLoadingOverlay === 'function') {
        cartModal.hideLoadingOverlay();
      }

      setTimeout(function () {
        btn.textContent = originalText;
        btn.disabled = false;
      }, 1500);
    })
    .catch(function () {
      btn.textContent = 'Try Again';
      btn.disabled = false;
      if (cartModal && typeof cartModal.hideLoadingOverlay === 'function') {
        cartModal.hideLoadingOverlay();
      }
    });
}

// Use JS scroll animation on mobile to bypass overflow-x hidden issue
(function() {
  var ticker = document.getElementById('kaayuTicker');
  if (!ticker) return;

  if (window.innerWidth <= 768) {
    ticker.style.animation = 'none';
    var pos = 0;
    var speed = 0.5;
    var paused = false;
    var totalWidth = ticker.scrollWidth / 2;

    ticker.parentElement.style.overflowX = 'hidden';
    ticker.parentElement.style.overflowY = 'hidden';

    function animate() {
      if (!paused) {
        pos += speed;
        if (pos >= totalWidth) pos = 0;
        ticker.style.transform = 'translateX(-' + pos + 'px)';
      }
      requestAnimationFrame(animate);
    }

    ticker.addEventListener('touchstart', function() { paused = true; });
    ticker.addEventListener('touchend', function() { paused = false; });

    requestAnimationFrame(animate);
  }
})();

function kaayuOpenLightbox(card) {
  var media = card.querySelector('.kaayu-celeb-media');
  var src = media.dataset.src;
  var type = media.dataset.type;
  var name = card.querySelector('.kaayu-celeb-username').textContent;
  var role = card.querySelector('.kaayu-celeb-role').textContent;
  var lbMedia = document.getElementById('kaayuLightboxMedia');
  if (type === 'video') {
    lbMedia.innerHTML = '<video src="' + src + '" autoplay controls loop playsinline style="width:100%;max-height:500px;"></video>';
  } else {
    lbMedia.innerHTML = '<img src="' + src + '" style="width:100%;max-height:500px;object-fit:contain;" />';
  }
  document.getElementById('kaayuLightboxUser').textContent = name + ' · ' + role;
  document.getElementById('kaayuLightbox').classList.add('active');
  document.body.style.overflow = 'hidden';
}

function kaayuCloseLightbox(e) {
  if (e && e.target !== document.getElementById('kaayuLightbox') && !e.target.classList.contains('kaayu-lightbox-close')) return;
  document.getElementById('kaayuLightbox').classList.remove('active');
  document.getElementById('kaayuLightboxMedia').innerHTML = '';
  document.body.style.overflow = '';
}

document.addEventListener('keydown', function(e) {
  if (e.key === 'Escape') kaayuCloseLightbox({target: document.getElementById('kaayuLightbox')});
});
